export default __webpack_public_path__ + "static/media/agp-example.f270c987.png";